module.exports = __webpack_public_path__ + "static/media/lucy4cloud-logo.6c30ef9e.svg";